<template>
    <a-modal
      :visible="moveToData ? true : false"
      title="Move Country"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-row>
        <a-col :xs="24" :lg="24">
          <!-- 国家 -->
          <a-form-item>
            <span slot="label">Move <strong>{{ moveToData ? moveToData.nameEnUs : '' }}</strong> after</span>
            <a-select
              v-model="moveToCurrentId"
              style="width: 100%;"
              :showSearch="true"
              optionFilterProp="children"
              v-decorator="[
                'countryId',
                { rules: [{ required: true, message: 'Please select a country!' }] },
              ]"
            >
              <a-select-option :value="'top'">Top</a-select-option>
              <a-select-option v-for="i in countryList" :key="'country-' + i.id" :value="i.id">{{ i.nameEnUs }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <template slot="footer">
          <a-button type="primary" @click="handleOk" :loading="saving">
            Confirm
          </a-button>
      </template>
    </a-modal>
</template>

<script>
import CountryApi from '@/api/basicdata/api-country'

export default {
  name: 'CountryMove',
  components: {
  },
   props: {
    initData: {
      type: [Object],
      default: null
    }
  },
  data () {
    return {
      countryList: [],
      moveToData: null,
      moveToCurrentId: null,
      saving: false,
    }
  },
  created () {
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.saving = false
      this.moveToCurrentId = 'top'
      this.moveToData = this.initData
      const resCountry = await CountryApi.list()
      const countryList = resCountry.data
      this.countryList = countryList

    },
    async handleOk () {
      this.saving = false
      if (this.moveToCurrentId === 'top') {
        await CountryApi.moveTo(this.moveToData.id)
      } else {
        await CountryApi.moveTo(this.moveToData.id, this.moveToCurrentId)
      }
      this.saving = true
      this.$emit('ok')
    },
    handleCancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    initData () {
      this.loadData()
    }
  }
}
</script>
